/**
 * input-device.ts — 偵測「是否觸控裝置」(無實體鍵盤)。
 *
 * 緣由(boss 2026-06-13「上面好像都弄不到」):戰力槽滿時的提示寫死
 * 「按 空白 釋放」,但手機/平板沒有空白鍵 → 玩家找不到怎麼放大絕(其實要
 * 點右下角的 ⚡ 鈕)。UI 文案要依裝置改寫,故抽出這個共用偵測。
 *
 * 判準與 touch-controls.ts mountTouchControls() 一致(ontouchstart /
 * maxTouchPoints),再加 `(pointer: coarse)` media query 補強。全程 try/guard,
 * 在 jsdom / headless(無 window / matchMedia)一律回 false,不丟錯。
 */
export function isTouchDevice(): boolean {
  try {
    if (typeof window === 'undefined') return false;
    if ('ontouchstart' in window) return true;
    const nav = typeof navigator !== 'undefined' ? navigator : undefined;
    if (nav && typeof nav.maxTouchPoints === 'number' && nav.maxTouchPoints > 0) return true;
    if (typeof window.matchMedia === 'function') {
      try {
        if (window.matchMedia('(pointer: coarse)').matches) return true;
      } catch { /* matchMedia may throw on bad query in old jsdom */ }
    }
  } catch { /* defensive: any access error → treat as non-touch */ }
  return false;
}
